import {
    StepVariables,
    ToolContext
} from "@omni/types/components/tracking/tracking-info/tools/toolStep.trackingInfo";

type StepTypes = "start" | "submit";

const TOOL_CONTACT_STEPS: Record<StepTypes, StepVariables> = {
    start: {
        stepName: "neem contact met ons op",
        stepNumber: 1,
        placement: "contact:klantendienst",
        result: {},
        option: ""
    },
    submit: {
        stepName: "contact gesubmit",
        stepNumber: 2,
        placement: "contact:klantendienst",
        result: {}, //customerId + store + rubriek
        option: ""
    }
};

const TOOL_CONTACT_CONTEXT: Readonly<ToolContext> = {
    name: "contact form",
    type: "form"
};

export { TOOL_CONTACT_CONTEXT, TOOL_CONTACT_STEPS };
